module.exports = __webpack_public_path__ + "/login_ui/img/fr-a2504ba65589c6948605410fb7c470af.svg";